import React, { useState } from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import * as S from './styles';
import ArbitrationMatches from './components/ArbitrationMatches';
import TeamBlock from '../TeamBlock';
import { TabBar, TabButton } from '~/components';

export default function ArbitrationBlock({
  name,
  avatar,
  arbitrationCollege,
  matches,
  className,
  totalMatches,
  localStats,
  awayStats,
  selectedMatch,
}) {
  const [tab, setTab] = useState('referee');

  const changeTab = ({ value }) => {
    setTab(value);
  };

  const { t } = useTranslation();
  return (
    <S.Container className={className}>
      <S.ArbitrationHeaderStyled
        name={name}
        avatar={avatar}
        arbitrationCollege={arbitrationCollege}
      />
      {matches && (localStats || awayStats) && (
        <TabBar value={tab} onChange={changeTab}>
          <TabButton value="referee" label={t('refereeMatches')} />
          {localStats && (
            <TabButton
              value="local"
              label={selectedMatch ? selectedMatch.homeTeam.nickname : '----'}
            />
          )}
          {awayStats && (
            <TabButton
              value="away"
              label={selectedMatch ? selectedMatch.awayTeam.nickname : '----'}
            />
          )}
        </TabBar>
      )}
      {tab === 'referee' && matches && (
        <ArbitrationMatches matches={matches} totalMatches={totalMatches} />
      )}
      {tab === 'local' && localStats && (
        <TeamBlock isLocal value={localStats} />
      )}
      {tab === 'away' && awayStats && <TeamBlock value={awayStats} />}
    </S.Container>
  );
}

ArbitrationBlock.propTypes = {
  className: PropTypes.string,
  avatar: PropTypes.string,
  arbitrationCollege: PropTypes.string,
  name: PropTypes.string,
  matches: PropTypes.array,
  totalMatches: PropTypes.object,
  localStats: PropTypes.object,
  awayStats: PropTypes.object,
  selectedMatch: PropTypes.object,
};

ArbitrationBlock.defaultProps = {
  className: null,
  avatar: null,
  arbitrationCollege: null,
  name: null,
  matches: [],
  totalMatches: null,
  localStats: null,
  awayStats: null,
  selectedMatch: null,
};
